<template>
    <div class="flex flex_column flex_between">
        <UserDetailForm class="flex flex_column w_100 modal-content modal-content--in-group"
                        :email-disable="isEditMode"
                        :info="userDetails"
                        ref="userDetails"
        ></UserDetailForm>
        <div class="flex flex_between w_100 margin_top">
            <div class="flex">
                <md-button v-if="canDisableUser" class="md-block" @click="disableUser">
                    {{$t('common.button.disable')}}
                </md-button>
                <md-button v-if="canEnableUser" class="md-success" @click="enableUser">
                    {{$t('common.button.enable')}}
                </md-button>
                <md-button v-if="canDeleteUser" class="md-block" @click="deleteUser">
                    {{$t('common.button.delete')}}
                </md-button>
            </div>
            <div class="flex">
                <md-button class="md-blank margin_r" @click="close">
                    {{$t('common.button.close')}}
                </md-button>
                <md-button v-if="hasNext && !userData.id" class="md-primary" @click="next">
                    {{$t('common.continue')}}
                </md-button>
                <md-button v-else-if="saveOnly" class="md-primary" @click="submit">
                    {{$t('common.save')}}
                </md-button>
                <md-button v-else class="md-primary" @click="submit">
                    {{$t('common.button.submit')}}
                </md-button>

            </div>
        </div>
    </div>
</template>

<script>
import UserDetailForm from "@/components/templates/common/UserDetailForm";
import {traderTeamManagementApi} from "@/common/api/traderTeamManagementApi";
import {enumDef} from "@/common/enumDefs";

export default {
    props: {
        userData: { type: Object, default: null },
        hasNext: { type: Boolean, default: null },
        saveOnly: { type: Boolean, default: false }
    },
    components: {
        UserDetailForm
    },
    data() {
        return {
            userDetails: null,
        };
    },
    computed: {
        isEditMode() {
            return this.userData && this.userData.id;
        },
        canDisableUser() {
            return this.isEditMode
                && this.currentUser.level < this.userData.userLevel
                && this.userData.userStatus === enumDef.userStatus.Active;
        },
        canEnableUser() {
            return this.isEditMode
                && this.currentUser.level < this.userData.userLevel
                && enumDef.userStatus.isDisabled(this.userData.userStatus);
        },
        canDeleteUser() {
            return this.isEditMode
                && this.currentUser.level < this.userData.userLevel
                && this.userData.userStatus === enumDef.userStatus.New;
        },
    },
    mounted() {
        this.loadUserDetails();
    },
    methods: {
        loadUserDetails() {
            if (!this.userData || !this.userData.id) {
                return;
            }

            traderTeamManagementApi.inspection.getUserDetails(this.userData.id)
                .then(res => {
                    this.userDetails = res;
                }).catch(e => {
                    this.toast(e);
                });
        },
        disableUser() {
            this.$emit("disable");
        },
        enableUser() {
            this.$emit("enable");
        },
        deleteUser() {
            this.$emit("delete");
        },
        getData() {
           return this.$refs.userDetails ? this.$refs.userDetails.getInfo() : null;
        },
        submit() {
            if (!this.validate()) {
                return;
            }

            this.$emit("submit");
        },
        next() {
            if (!this.validate()) {
                return;
            }

            this.$emit("next");
        },
        close() {
            this.$emit("close");
        },
        validate() {
            return this.$refs.userDetails.validate();
        }
    },
    watch: {
        userData() {
            this.loadUserDetails();
        },
    }
};
</script>